import { defineMessages } from 'react-intl';

export default defineMessages({
  openMenu: {
    id: 'view.appBar.openMenu',
    defaultMessage: 'Open navigation menu',
  },
  closeMenu: {
    id: 'view.appBar.closeMenu',
    defaultMessage: 'Close navigation menu',
  },
});
